import { render, staticRenderFns } from "./TableBens.vue?vue&type=template&id=0481a497&scoped=true&"
import script from "./TableBens.vue?vue&type=script&lang=js&"
export * from "./TableBens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0481a497",
  null
  
)

export default component.exports